import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const propTypes = {
  urls: PropTypes.arrayOf(PropTypes.string).isRequired,
};
const defaultProps = {};

const DescendantPagesUrlList = ({ urls }) => {
  const descendantPageUrlsList = (
    <div className={styles.descendantUrls}>
      <ul>
        {urls.map(url => <li key={url} className={styles.url}>{url}</li>)}
      </ul>
    </div>
  );

  return (
    <React.Fragment>
      {descendantPageUrlsList}
    </React.Fragment>
  );
};

DescendantPagesUrlList.propTypes = propTypes;
DescendantPagesUrlList.defaultProps = defaultProps;

export default DescendantPagesUrlList;
